export const DEAL_REFRESH_APP_NAME_WHITELIST = ['CMD', 'AMD'] as const;

// Common Consumer-relayed events carry versionCreatedBy.applicationName 'Common Consumer'. Unlike
// CMD/AMD (always whitelisted, edition-gated), this source is added to the whitelist only when the
// enableCommonConsumerPersonaFallback feature toggle is on — see getDealRefreshAppNameWhitelist.
export const COMMON_CONSUMER_APP_NAME = 'Common Consumer';
